import {
  BaseAllotmentStatus,
  type ActivityCalendarDailyAvailability
} from '@linktivity/ars-neo';
import {
  ALLOTMENT_STATUS,
  type AllotmentStatusType
} from '@link/share/constants';
import { calculateAllotmentStatus } from '@link/share/utils';

export type CalendarDay = ActivityCalendarDailyAvailability;
export type StockStatus = AllotmentStatusType;

/**
 * The stock mark a day shows. `bookable` is the caller's own verdict on the
 * day, taken as given so the mark never disagrees with whether the day can be
 * picked.
 */
export const dayStockStatus = (
  day: CalendarDay | undefined,
  bookable: boolean
): StockStatus => {
  if (!day) return ALLOTMENT_STATUS.SOLD_OUT;
  const isUnlimited =
    day.allotmentStatus === BaseAllotmentStatus.AllotmentStatusUnlimited;
  const isAllocable =
    isUnlimited ||
    day.allotmentStatus === BaseAllotmentStatus.AllotmentStatusAllocable;
  return calculateAllotmentStatus(
    bookable,
    isAllocable,
    day.allotmentQuantity ?? 0,
    isUnlimited
  );
};
